// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';

export const resetProductDetails = () => ({
    type: actions.RESET_CLAIM_MAINTENANCE_PLAN_PRODUCT_DETAILS
});



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/reset-product-details.js